import { MyTextField } from '@interstellar-component'
import {
  PHONE_COUNTRY_CODE,
  PHONE_HELPER_TEXT,
  PHONE_INPUT_REGEX,
  PHONE_MAX_DIGITS,
} from '@services/phone'

// Shared phone-number field. Renders a static "+62" prefix on the left; the
// user types only the national part (digits, no leading 0 — a leading 0 keypress
// is dropped). The form value is the national part; convert to/from storage with
// `toNationalPhone` / `toE164Phone` from "@services/phone".
//
// Works in both react-hook-form mode (pass `control`) and controlled mode
// (pass `value` + `onChangeForm`), exactly like MyTextField.
export default function PhoneInput({
  helperText = PHONE_HELPER_TEXT,
  placeholder = '81234567890',
  startIcon = null,
  ...props
}) {
  return (
    <MyTextField
      {...props}
      type="text"
      inputMode="numeric"
      placeholder={placeholder}
      helperText={helperText}
      validationRegex={PHONE_INPUT_REGEX}
      maxLength={PHONE_MAX_DIGITS}
      startAdornment={
        <span className="text-md-medium flex items-center gap-1.5 text-gray/700">
          {startIcon}
          {PHONE_COUNTRY_CODE}
        </span>
      }
    />
  )
}
